const pairs = `
기업소개|Our Story
핵심 역량|Core Competency
회사 연혁|History
파트너|Partners
문의하기|Contact Us
기업소개 (Our Story)|Our Story
핵심 역량 (Core Competency)|Core Competency
회사 연혁 (History)|History
파트너 (Partner)|Partners
디지털 헬스케어|Digital Healthcare
디지털 스포츠|Digital Sports
인사제도|Benefits
채용공고|Careers
SALTED 홈|SALTED home
주요 메뉴|Main navigation
전체 메뉴 닫기|Close menu
전체 메뉴 열기|Open menu
인류의 움직임을|Translating human movement
디지털로 번역하고,|into digital language,
삶의 가능성을 확장합니다.|expanding life's possibilities.
의료와 스포츠 현장에서 생성되는 인간의 움직임을 데이터로 연결해|Connecting human movement in healthcare and sports with data
더 나은 판단과 새로운 가능성을 만듭니다.|to support better decisions and new possibilities.
PhysioLink SDK 알아보기|Explore PhysioLink SDK
SALTED 소개|About SALTED
데이터 집계 중|Collecting data
최신 소식으로 이동|Go to latest updates
공지사항|Notices
주요 소식|News
행사 안내|Events
SALTED의 새로운 소식|The latest from SALTED
솔티드의 공지, 언론 보도와 주요 행사 소식을 한곳에서 확인하세요.|Explore SALTED announcements, media coverage and events.
등록된 소식이 없습니다.|No updates available.
인간 움직임을 연결하는|Connecting human movement
보이지 않는 인프라|through invisible infrastructure
디바이스와 데이터, 지능을 하나의 흐름으로 연결합니다.|Connecting devices, data and intelligence in one flow.
움직임 데이터 활용의 시작을 PhysioLink SDK와 함께하세요.|Start working with movement data through PhysioLink SDK.
SDK 자세히 보기|Explore the SDK
솔티드(주)는 혁신적인 솔루션으로|SALTED creates value
세상에 가치를 만들어갑니다.|through innovative solutions.
회사 정보|Company Information
경기도 하남시 미사강변한강로 135 다동 423호 (스카이폴리스)|Room 423, Building D, SkyPolis, 135 Misagangbyeonhangang-ro, Hanam-si, Gyeonggi-do, Korea
사업자등록번호: 611-81-27282|Business registration: 611-81-27282
연락처|Contact
고객지원|Customer Support
평일 09:00 - 18:00|Weekdays 09:00–18:00 (KST)
점심시간 12:30 - 13:30|Lunch break 12:30–13:30 (KST)
주말 및 공휴일 휴무|Closed on weekends and Korean public holidays
개인정보처리방침|Privacy Policy (Korean)
이용약관|Terms of Use (Korean)
쿠키 설정|Cookie Settings
전체|All
동작분석|Motion Analysis
보행분석|Gait Analysis
균형분석|Balance Analysis
척추환자|Spinal Conditions
근력/감각측정|Strength / Sensory Assessment
다운로드 링크가 없습니다.|No download link is available.
논문 및 연구자료|Publications & Research
본 연구는 스마트 인솔 센서를 활용하여 정상 보행과 8가지 비정상 보행 패턴을 분류하는 딥러닝 모델을 개발하였다.|A study developing a deep-learning model to classify normal gait and eight abnormal gait patterns using smart insole sensors.
본 연구는 고관절 골절 환자를 대상으로 스마트 인솔 기반 SPPB 평가와 기존 수기 평가 방법을 비교하였다.|A comparison of smart insole-based SPPB assessment and conventional manual assessment in patients with hip fractures.
본 연구는 만성 발목 불안정성 환자를 대상으로 스마트 인솔을 활용한 동적 안정성 평가 가능성을 검증하였다.|A study examining smart insoles for dynamic stability assessment in patients with chronic ankle instability.
본 연구는 스마트 인솔과 AI 기반 자세 추정을 활용하여 근감소증 분류 모델을 개발하였다.|A study developing a sarcopenia classification model using smart insoles and AI-based pose estimation.
본 연구는 스마트 인솔과 AI 기반 보행 분석을 활용하여 근감소증 환자의 신체 기능을 평가하고 디지털 바이오마커를 개발하는 것을 목표로 하였다.|A study investigating physical function assessment and digital biomarkers for sarcopenia using smart insoles and AI-based gait analysis.
본 연구는 만성 발목 불안정성 재활에서 올바른 힐 레이즈 자세를 식별할 수 있는 스마트 인솔 시스템을 제안하였다.|A proposed smart insole system for identifying proper heel-raise posture in chronic ankle instability rehabilitation.
디지털 헬스케어 연구|Digital Healthcare Research
솔티드의 연구 성과와 학술 논문을 확인하세요|Explore SALTED research and academic publications
총|Total:
개의 논문이 있습니다.|publications
제목|Title
저자|Author
검색어를 입력하세요.|Enter a search term.
검색|Search
데이터를 불러오는 중...|Loading…
발행일|Published
다운로드|Download
검색 결과가 없습니다.|No results found.
다운로드 불가|Unavailable
처음|First
이전|Previous
다음|Next
맨끝|Last
필수 항목을 모두 입력해주세요.|Please complete all required fields.
문의 내용은 500자를 초과할 수 없습니다.|Your message must be 500 characters or fewer.
개인정보 수집 및 이용에 동의해주세요.|Please agree to the collection and use of your personal information.
문의 양식|Contact Form
웹사이트|Website
성함 *|Name *
홍길동|Your name
연락처 *|Phone *
이메일 *|Email *
회사명|Company
회사명을 입력해주세요|Enter your company name
문의 제목 *|Subject *
문의 제목을 입력해주세요|Enter a subject
문의 내용 *|Message *
문의하실 내용을 자세히 작성해주세요 (최대 500자)|Describe your inquiry (up to 500 characters)
문의 처리를 위한 개인정보 수집 및 이용에 동의합니다.|I agree to the collection and use of my personal information to process this inquiry.
개인정보처리방침 보기|Read the Privacy Policy (Korean)
문의가 성공적으로 접수되었습니다. 빠른 시일 내에 답변드리겠습니다.|Your inquiry has been received. We will respond as soon as possible.
문의 접수 중 오류가 발생했습니다. 다시 시도해주세요.|Unable to submit your inquiry. Please try again.
전송 중...|Sending…
문의 보내기|Send Inquiry
문의해주신 내용은 영업일 기준 24시간 이내에 답변드리겠습니다.|We aim to respond within 24 business hours.
다시 시도|Try Again
등록된 기사가 없습니다.|No articles available.
기사 보러가기|Read Article
기사 상세|Article Details
기사 원문 보러가기|Read Original Article
기사|Articles
솔티드가 참여하고 진행하는 주요 행사 소식을 확인하세요.|Explore events hosted by or featuring SALTED.
다가오는 이벤트|Upcoming Events
등록된 이벤트가 없습니다.|No events available.
주최:|Organizer:
등록하기|Register
이벤트에 참여하세요|Join Our Events
솔티드의 다양한 행사와 이벤트에서 새로운 인사이트를 얻어가세요|Discover new insights at SALTED events.
서비스와 운영에 관한 주요 안내를 전합니다.|Important updates on our services and operations.
최신 공지사항|Latest Notices
등록된 공지사항이 없습니다.|No notices available.
카테고리|Category
날짜|Date
조회수|Views
공지사항 상세|Notice Details
첨부파일|Attachment
함께 만들어갈|Build the future
미래를 찾습니다|with us
인류의 움직임을 디지털로 번역하고 삶의 가능성을 확장할 인재를 기다립니다.|Join us in translating human movement into digital language and expanding life's possibilities.
솔티드는 구성원의 성장과 행복을|At SALTED, our people's growth and well-being
최우선으로 생각합니다|come first
최고의 인재가 최고의 성과를 낼 수 있도록|We provide the environment and benefits
최적의 환경과 복지를 제공합니다|that help our people do their best work
유연근무제|Flexible Hours
출퇴근 시간을 자유롭게 조정할 수 있는 유연근무제를 운영합니다. 개인의 라이프스타일에 맞춰 최적의 업무 환경을 만들어가세요.|Adjust your start and finish times through our flexible working arrangements to suit your lifestyle.
건강관리 지원|Health & Well-being
연 1회 종합건강검진을 지원하며, 헬스케어 관련 복지 프로그램을 제공합니다. 건강한 몸과 마음으로 일할 수 있도록 돕습니다.|We support annual health checkups and healthcare benefits to help our people stay healthy.
교육 및 성장 지원|Learning & Development
업무 관련 교육비, 도서 구입비, 컨퍼런스 참가비를 지원합니다. 지속적인 학습과 성장을 통해 전문성을 키워나가세요.|We support work-related training, books and conference attendance for continued professional growth.
수평적 조직문화|Collaborative Culture
직급과 나이에 관계없이 서로를 존중하는 수평적 문화를 지향합니다. 자유로운 의견 교환과 소통을 통해 함께 성장합니다.|We respect one another regardless of position or age and grow through open communication.
경조사 지원|Life Event Support
결혼, 출산, 경조사 등 인생의 중요한 순간을 함께합니다. 경조금 지원과 특별 휴가를 제공합니다.|We provide financial support and special leave for important life events.
사내 복지|Workplace Benefits
간식과 음료가 항상 준비되어 있으며, 쾌적한 업무 환경을 위한 최신 장비와 편의시설을 제공합니다.|Snacks, drinks, modern equipment and workplace amenities support a comfortable working environment.
근무 환경|Working Environment
최고의 성과는|Great work begins
최적의 환경에서 나옵니다|with the right environment
솔티드는 구성원들이 업무에만 집중할 수 있도록|SALTED provides a comfortable and efficient workplace
쾌적하고 효율적인 근무 환경을 제공합니다.|so our people can focus on their work.
최신 장비와 소프트웨어, 편안한 휴게 공간,|Modern equipment and software, comfortable break areas,
그리고 협업을 위한 다양한 미팅룸을 갖추고 있습니다.|and meeting rooms support collaboration.
현재 채용 중인 포지션을 확인해보세요|Explore our current openings
채용공고 보기|View Open Positions
연구개발|Research & Development
제품개발|Product Development
디자인|Design
마케팅|Marketing
경영지원|Business Operations
자기소개서는 500자를 초과할 수 없습니다.|Your personal statement must be 500 characters or fewer.
이력서는 5MB 이하 PDF 파일만 첨부할 수 있습니다.|Please attach a PDF resume of 5 MB or less.
지원서가 성공적으로 제출되었습니다. 검토 후 연락드리겠습니다.|Your application has been submitted. We will contact you after reviewing it.
제출 중 오류가 발생했습니다. 다시 시도해주세요.|Unable to submit your application. Please try again.
솔티드와 함께 세상을 바꿀|Join SALTED
동료를 찾습니다|and make a difference
현재 채용 중인 포지션이 없습니다.|There are no open positions at present.
마감:|Deadline:
지원하기|Apply
궁금한 점이 있으신가요?|Have a Question?
채용 관련 문의사항이 있으시면 언제든 연락해주세요|Contact us with any questions about careers at SALTED.
직무 소개|Role Overview
자격 요건|Requirements
혜택 및 복지|Benefits
입사 지원서|Job Application
이름 *|Name *
지원 포지션 *|Position *
포지션을 선택해주세요|Select a position
이력서 첨부|Attach Resume
PDF 파일만 가능하며 최대 용량은 5MB입니다|PDF only, up to 5 MB
채용 지원을 위한 개인정보 수집 및 이용에 동의합니다.|I agree to the collection and use of my personal information for this job application.
자기소개서 *|Personal Statement *
지원 동기와 본인의 강점을 작성해주세요 (최대 500자)|Tell us why you are applying and describe your strengths (up to 500 characters)
취소|Cancel
제출 중...|Submitting…
쿠키 사용 안내|Cookie Notice
분석 쿠키 설정|Analytics Cookie Settings
필수 기능은 항상 사용합니다. 동의하면 Google Analytics를 통해 방문 통계를 수집해 홈페이지를 개선합니다. 자세한 내용은|Essential features are always available. With your consent, we use Google Analytics to understand visits and improve this website. Learn more in our
에서 확인할 수 있습니다.|.
분석 쿠키 허용|Allow Analytics
필수 항목만|Essential Only
솔티드의 성장 여정|Our Journey
삼성전자 Spin-off부터 물리 데이터 기업으로의 도약|From Samsung spin-off to physical data company
솔티드의 성장 스토리|The SALTED Story
KIST 기술이전 계약 체결|KIST Technology Transfer Agreement
중소벤처기업부 장관상 수상|Award from the Minister of SMEs and Startups
2026 대한민국 창업문화대상 — 디지털 헬스케어 상용화와 정밀의료 생태계 발전에 기여|2026 Korea Startup Culture Awards — Recognized for commercializing digital healthcare and advancing the precision medicine ecosystem
동아ST와 뉴로게이트 국내 독점 판매 계약 체결|Exclusive Domestic Distribution Agreement with Dong-A ST for NEUROGAIT
동아ST의 의료기관 네트워크와 솔티드의 보행분석 기술을 연결해 뉴로게이트 공급 확대|Expanding NEUROGAIT distribution by combining Dong-A ST’s healthcare network with SALTED’s gait analysis technology
동아ST|Dong-A ST
한국과학기술연구원과의 기술 협력 강화|Strengthening technology collaboration with KIST
뉴로게이트 모션(디지털의료기기) 품목 신고 승인|NEUROGAIT Motion Digital Medical Device Notification Accepted
인공지능 기반 관절가동범위 및 전신 움직임 평가 소프트웨어|AI-based range-of-motion and whole-body movement assessment software
디지털의료기기 제조업 허가|Digital Medical Device Manufacturing License
디지털의료기기 제조를 위한 허가 취득|Obtained a license for digital medical device manufacturing
ISO 13485 인증 취득|ISO 13485 Certification
의료기기 품질경영시스템 국제표준 인증 취득|International certification for medical device quality management
삼성증권 대표 주관사 선정|Samsung Securities Selected as Lead IPO Manager
기업공개(IPO) 추진을 위한 준비 본격화|Advancing preparations for an initial public offering
글로벌 보행 지능 표준 구축 연구|Research on Global Gait Intelligence Standards
서울대병원, 분당서울대학교병원 공동연구협약 체결|Joint research agreements with Seoul National University Hospital and Seoul National University Bundang Hospital
디지털 바이오마커 연구: 파킨슨병 중증도 모니터링, 당뇨족부궤양 예방·관리 솔루션|Digital biomarker research: Parkinson's severity monitoring and diabetic foot ulcer prevention and management
국내 의료 시장 본격 진입|Entry into the Korean Medical Market
의료기기 시장 확대 및 본격적인 사업화|Expanding medical device commercialization
50개 이상 거점 병원 도입|Adoption at More Than 50 Hospitals
전국 주요 병원 네트워크 구축 완료|Establishing a network of hospitals across Korea
'Neurogait' 보행분석 솔루션 공식 런칭|Official Launch of NEUROGAIT Gait Analysis
차세대 보행분석 플랫폼 정식 출시|Launching our next-generation gait analysis platform
국내 지역별 총판 계약 체결|Regional Distribution Agreements in Korea
전국 유통 네트워크 확립|Establishing a nationwide distribution network
국내 제약사 판매 계약 체결|Sales Agreements with Korean Pharmaceutical Companies
주요 제약사와의 전략적 파트너십 구축|Building strategic pharmaceutical partnerships
주요 병원 임상 유효성 확보|Clinical Validation at Major Hospitals
임상 연구 결과 논문 발표 및 의료계 인정|Publishing clinical research and gaining medical recognition
FDA 허가 획득|FDA Clearance
미국 식품의약국 승인으로 글로벌 시장 진출 기반 마련|Establishing a foundation for global market entry through FDA clearance
의료 수가 및 치료재료 등재|Listing of Medical Fees and Treatment Materials
법정 비급여(EZ777), 치료재료(BM0900EI) 등재|Listed under non-reimbursed code EZ777 and treatment material code BM0900EI
Series B 투자 유치|Series B Funding
디지털 의료기기 시장 진입을 위한 투자 유치 성공|Securing investment for entry into digital medical devices
혁신기업 국가대표 1000 선정|Selected for Korea's Innovative Enterprises 1000
대한민국 대표 혁신기업으로 인정|Recognized among Korea's leading innovative companies
1등급 의료기기 등재|Class I Medical Device Registration
스마트 인솔 기반 의료기기 식품의약품안전처 승인|MFDS registration of a smart insole medical device
Amazon (US) Best Seller Product 선정|Amazon US Best Seller
미국 아마존 베스트셀러 제품 등극|Achieving best-seller status on Amazon US
대한민국 스포츠산업대상 장관상 수상|Ministerial Award at the Korea Sports Industry Awards
문화체육관광부 장관상 수상|Award from the Minister of Culture, Sports and Tourism
Series A 투자 유치|Series A Funding
본격적인 사업 확장을 위한 투자 유치 성공|Securing investment to expand the business
디지털 스포츠 솔루션 출시|Digital Sports Solution Launch
골프 및 트레이닝 분야 솔루션 정식 출시|Launching solutions for golf and training
CES 혁신상 수상|CES Innovation Award
세계 최대 전자제품 박람회 CES Innovation Award 수상|Receiving a CES Innovation Award
Health &amp; Fitness 부문 금상 수상|Gold Award in Health & Fitness
삼성전자 Spin-off 1기|First Samsung Electronics Spin-off Cohort
솔티드㈜ 법인 설립|Establishment of SALTED Co., Ltd.
벤처기업 인증 획득|Venture Enterprise Certification
혁신 기술 기업으로서의 첫 발걸음|Our first step as an innovative technology company
숫자로 보는 솔티드의 성장|SALTED in Numbers
주요 성과|Key Milestones
1등|No. 1
디지털 인솔 분야|Digital Insoles
글로벌 인솔 디바이스 시장|Global insole device market
물리 데이터 확보|Physical Data
의료 임상 데이터 및 스포츠 퍼포먼스 데이터 확보|Clinical and sports performance data
150+억원|KRW 15 billion+
투자 유치|Investment Raised
시리즈 B 투자 유치|Series B funding
의료기관 사용처 확보|Medical Institution Adoption
식약처 승인 의료기기|MFDS-registered medical device
솔티드와 함께 시작하세요|Get Started with SALTED
혁신적인 솔루션으로 여러분의 비즈니스를 다음 단계로 이끌어드립니다|Take your business forward with our innovative solutions
삼성벤처투자|Samsung Venture Investment
신한투자증권|Shinhan Securities
신한캐피탈|Shinhan Capital
신한자산운용|Shinhan Asset Management
KB증권|KB Securities
솔리더스인베스트먼트|Solidus Investment
인라이트벤처스|Enlight Ventures
포스코기술투자|POSCO Technology Investment
미시간벤처캐피탈|Michigan Venture Capital
한국벤처투자|Korea Venture Investment
삼성전자|Samsung Electronics
국립재활원|National Rehabilitation Center
국립암센터|National Cancer Center
서울대학교병원|Seoul National University Hospital
분당서울대학교병원|Seoul National University Bundang Hospital
서울성모병원|Seoul St. Mary's Hospital
성빈센트병원|St. Vincent's Hospital
세브란스병원|Severance Hospital
인하대학교병원|Inha University Hospital
남양주백병원|Namyangju Baek Hospital
우리들병원|Wooridul Hospital
참포도나무병원|Cham Podonamu Hospital
함께 성장하는 파트너십|Partnerships for Growth
더 나은 가능성을|Building new possibilities
파트너와 함께 만듭니다.|together with our partners.
솔티드는 각 분야의 기술과 전문성을 연결해 더 나은 헬스케어와 스포츠 환경을 만들어 갑니다.|SALTED connects technology and expertise to build better healthcare and sports environments.
파트너와의 협력을 통해 움직임 데이터의 활용 범위를 넓혀 갑니다.|Together with our partners, we expand the applications of movement data.
가나다순 정렬|Sort A–Z
가나다 역순 정렬|Sort Z–A
조형진|Hyungjin Cho
대표이사, 솔티드 주식회사|CEO, SALTED Co., Ltd.
솔티드 주식회사|SALTED Co., Ltd.
움직임 데이터가 필요한 비즈니스와 연구에 솔티드의 기술을 연결해 보세요.|Connect SALTED technology to your business and research in movement data.
움직임을 이해하고 가능성을 확장하는 솔티드의 브랜드 아이덴티티|SALTED's brand identity: understanding movement and expanding possibilities
브랜드를 일관되게 표현하기 위한 SALTED의 공식 브랜드 아이덴티티와 디자인 원칙을 소개합니다.|Explore SALTED's official brand identity and principles for consistent design.
브랜드 가이드 보기|View Brand Guide
자료 다운로드|Download Assets
SALTED 공식 워드마크|Official SALTED wordmark
움직임을 이해하고,|Understanding movement,
가능성을 확장합니다.|expanding possibilities.
솔티드는 인간의 움직임을 정확한 물리 데이터로 전환하고, 더 나은 판단과 새로운 가능성으로 연결합니다.|SALTED translates human movement into precise physical data, supporting better decisions and new possibilities.
관찰|Observe
몸의 움직임에서 의미 있는 신호를 발견합니다.|Discover meaningful signals in human movement.
변환|Translate
물리적 움직임을 이해 가능한 데이터로 번역합니다.|Translate physical movement into understandable data.
확장|Expand
데이터를 통해 의료와 스포츠의 가능성을 넓힙니다.|Expand the possibilities of healthcare and sports through data.
단순하고 선명한|A clear and simple
공식 워드마크|official wordmark
SALTED 워드마크는 원본의 비례와 형태를 유지하며 밝은 배경에는 블랙, 어두운 배경에는 화이트 버전을 사용합니다.|Preserve the wordmark's original proportions and shape. Use black on light backgrounds and white on dark backgrounds.
SALTED 블랙 워드마크|SALTED black wordmark
SALTED 화이트 워드마크|SALTED white wordmark
PNG 다운로드|Download PNG
절제된 컬러와|Refined colors and
명확한 타이포그래피|clear typography
깊이 있는 네이비와 정제된 뉴트럴 컬러를 중심으로, 전문성과 가독성을 일관되게 유지합니다.|Deep navy and refined neutral colors create consistent professionalism and readability.
SALTED 핵심 컬러|SALTED Core Colors
가나다라마바사|ABCDEFG
보호 공간, 최소 크기, 금지 규정 등 세부 사용 기준은 공식 브랜드 가이드에서 확인할 수 있습니다.|See the official brand guide for clear space, minimum size and prohibited uses.
상세 브랜드 가이드 보기|View Full Brand Guide
하나의 원칙,|One principle,
다양한 접점|many touchpoints
디지털, 헬스케어, 스포츠와 공간으로 확장되는 SALTED의 브랜드 경험을 보여줍니다.|Explore SALTED brand applications across digital experiences, healthcare, sports and spaces.
위 이미지는 브랜드 활용 방향을 보여주는 콘셉트 예시이며 실제 제품 사양이나 출시물을 의미하지 않습니다.|These images are brand application concepts, not actual product specifications or released products.
외부 제작물에는 제공된 공식 원본 파일을 사용하고, 로고 가이드의 사용 규정을 준수해 주세요.|Use the official source files and follow the logo guidelines for external materials.
AI 원본|AI Source File
로고 가이드|Logo Guide
브랜드 사용에 대해 문의하세요|Ask About Brand Usage
협업, 보도, 제작물에 필요한 CI 사용 범위를 안내해 드립니다.|Contact us about brand usage for collaborations, media and production.
`;
export const siteTranslations: Record<string,string> = Object.fromEntries(pairs.trim().split('\n').map(row=>{const split=row.indexOf('|');return [row.slice(0,split),row.slice(split+1)]}));
